import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VcsService } from '../../../services/vcs.service';
import { VcsAPIService } from '@wms/app/vcs/services/vcs-api/vcs-api.service';
import { BaseComponent } from '../../../../components/base/base.component';
import { NotificationService } from '@wms/app/services';
import { WmsDialogComponent } from '../../../../components/wms-dialog/wms-dialog.component';
import { WmsDialogHeaderComponent } from '../../../../components/wms-dialog-header/wms-dialog-header.component';
import { WmsDialogBodyComponent } from '../../../../components/wms-dialog-body/wms-dialog-body.component';
import { WmsDialogFooterComponent } from '../../../../components/wms-dialog-footer/wms-dialog-footer.component';
import { DiffEditorComponent } from '../../diff-editor/diff-editor.component';
import { IchildFile } from '@wms/app/vcs/interface/child-file';

@Component({
  selector: 'wms-wms-vcs-compare-file-diff-dialog',
  standalone: true,
  imports: [
    CommonModule,
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    DiffEditorComponent,
  ],
  templateUrl: './wms-vcs-compare-file-diff-dialog.component.html',
  styleUrls: ['./wms-vcs-compare-file-diff-dialog.component.less'],
})
export class WmsVcsCompareFileDiffDialogComponent extends BaseComponent {
  public vcsService: VcsService;
  private vcsAPIService: VcsAPIService;
  private notificationService: NotificationService;

  constructor() {
    super();
    this.vcsService = inject(VcsService);
    this.vcsAPIService = inject(VcsAPIService);
    this.notificationService = inject(NotificationService);
  }

  revertDiffFile() {
    let fileToRevert: IchildFile = this.vcsService.diffFileDetails;
    fileToRevert.showDiff = true;
    this.vcsAPIService.revertChanges([fileToRevert],this.vcsService.changesType).then((): void => {
      this.vcsService.closeDialogWithId('diffEditorModal');
      window.location.reload();
    });
  }

  saveModifiedFile() {
    this.vcsAPIService
      .saveModifiedFile(
        this.vcsService.diffFileDetails.filepath,
        this.vcsService.diffEditor.editor().getValue()
      )
      .then((): void => {
        this.vcsService.closeDialogWithId('diffEditorModal');
        this.notificationService.show(
          'success',
          '',
          this.locale['MESSAGE_SUCCESS_FILE_WRITE_DESC']
        );
        this.vcsService.reloadProject = true
      });
  }

  closeCompareDiffModal() {
    this.vcsService.closeDialogWithId('diffEditorModal')
    this.vcsService.isTwoWayModalOpened = false
  }
}
